export const RETRIEVE_SOURCES_BEGIN = 'RETRIEVE_SOURCES_BEGIN';
export const RETRIEVE_SOURCES_SUCCESS = 'RETRIEVE_SOURCES_SUCCESS';
export const RETRIEVE_SOURCES_FAILURE = 'RETRIEVE_SOURCES_SUCCESS';
export const UPDATE_SOURCES_BEGIN = 'UPDATE_SOURCES_BEGIN';
export const UPDATE_SOURCES_SUCCESS = 'UPDATE_SOURCES_SUCCESS';
export const UPDATE_SOURCES_FAILURE = 'UPDATE_SOURCES_FAILURE';
export const DELETE_FACEBOOK_CONNECTION_BEGIN = 'DISONNECT_FACEBOOK_BEGIN';
export const DELETE_FACEBOOK_CONNECTION_SUCCESS = 'DELETE_FACEBOOK_CONNECTION_SUCCESS';
export const DELETE_FACEBOOK_CONNECTION_FAILURE = 'DELETE_FACEBOOK_CONNECTION_FAILURE';
export const FACEBOOK_APP_ID             = '2503610633254017';
export const FACEBOOK_SOCIAL_ICOSNS_KEY  = 'facebook_for_sources_page';
export const FACEBOOK_CONNECT_SCOPE      = 'public_profile';
export const CHECK_FACEBOOK_CONNECTION_BEGIN = 'CHECK_FACEBOOK_CONNECTION_BEGIN';
export const CHECK_FACEBOOK_CONNECTION_SUCCESS = 'CHECK_FACEBOOK_CONNECTION_SUCCESS';
export const CHECK_FACEBOOK_CONNECTION_FAILURE = 'CHECK_FACEBOOK_CONNECTION_FAILURE';
export const UPDATE_FACEBOOK_CONNECTION_BEGIN   = 'UPDATE_FACEBOOK_CONNECTION_BEGIN';
export const UPDATE_FACEBOOK_CONNECTION_SUCCESS = 'UPDATE_FACEBOOK_CONNECTION_SUCCESS';
export const UPDATE_FACEBOOK_CONNECTION_FAILURE = 'UPDATE_FACEBOOK_CONNECTION_FAILURE';
export const FACEBOOK_CONNECTION_ERROR_MSG = " Error while trying to connect to Facebook.";
export const FACEBOOK_CONNECTION_SUCCESS_MSG = ' Successfully connected to Facebook.';
export const FACEBOOK_DISCONNECT_SUCCESS_MSG = ' Successfully disconnected from Facebook.';
export const FACEBOOK_SOURCE_NAME            = 'facebook';
export const REDDIT_SOURCE_NAME              = "reddit";
export const YOUTUBE_SOURCE_NAME             = "youtube";
export const INSTAGRAM_SOURCE_NAME           = "instagram";
export const TIKTOK_SOURCE_NAME              = "tiktok";
export const SOCIAL_MEDIA_SOURCE_TYPE        = 'social media';
export const SOURCE_NAMES_SEPARATOR          = ';';
export const FORUM_PAGE_NAME_LABEL           = '(forum)';
export const CHECKED_CHECKBOX_CLASS          = 'checked';
export const UNCHECKED_CHECKBOX_CLASS        = 'unchecked';
export const INDETERMINATE_CHECKBOX_CLASS    = 'indeterminate';



// WEBPACK FOOTER //
// ./src/features/sources/redux/constants.js